export default __webpack_public_path__ + "static/media/living1.ce6bed3a.jpg";